
import SearchMap from './components/SearchMap.vue';

export default {
	name: 'search-result-view',
	components: { SearchMap },
	data: () => ({
		location: null,
		showMap: true,
		visibleSites: [],
		mapIsFullscreen: false
	}),
	props: {
		salons: {
			required: true,
			default: [],
			type: Array
		}
	},
	computed: {
	},
	methods: {
		// executeSearch(location, options = {}) {
		// 	this.searchExecute(location, { category: this.category, treatment: this.treatment, datetime: this.datetime, timeSlotStart: this.timeSlotStart, timeSlotEnd: this.timeSlotEnd, isGlobalSearch: options.isGlobalSearch });
		// },

		toggleFullScreenMap() {
			this.mapIsFullscreen = !this.mapIsFullscreen
		}
	},
	watch: {
		// $props: {
		// 	deep: true,
		// 	handler({ search }) {
		// 		if (search) {
		// 			this.location = search;
		// 		}
		// 	},
		// 	immediate: true
		// }
	},
	beforeDestroy() {
		// Make sure we reset fullscreen for the map
		if (this.mapIsFullscreen) {
			this.toggleFullScreenMap();
		}
	}
};
